import * as Features from '../../../../../../../shared/Features';
import { AuthenticatedUser } from '../../../../../../../shared/types';
import { IImageThumbnail } from '../../../Entities';
import { ImageEditorPhotoStatus } from '../../entry/queries/use-query-photo-status';

export enum ThumbnailActionIcon {
    UploadedNormal = 'uploaded-normal',
    NeedsEditing = 'needs-editing',
    OldNeedsEditing = 'old-needs-editing',
    HasComment = 'has-comment',
    HasOldComment = 'has-old-comment'
}

function canSeeNormalIcon(user: AuthenticatedUser, photoStatus: ImageEditorPhotoStatus): boolean {
    return (
        Features.hasFeature(Features.DownloadNormalImage, user) ||
        (photoStatus.photographerIsEditor &&
            Features.hasFeature(Features.HandleEditedImagesWhenPhotographerIsEditor, user))
    );
}

export function getThumbnailActionIcons(
    thumbnail: IImageThumbnail,
    user: AuthenticatedUser,
    photoStatus: ImageEditorPhotoStatus
): ThumbnailActionIcon[] {
    let icons: ThumbnailActionIcon[] = [];
    let canSeeNeedsEditing = Features.hasFeature(Features.ViewNeedsEditing, user);

    if (thumbnail.hasUploadedNormal && canSeeNormalIcon(user, photoStatus)) {
        icons.push(ThumbnailActionIcon.UploadedNormal);
    }

    if (canSeeNeedsEditing && thumbnail.needsEditing) {
        icons.push(ThumbnailActionIcon.NeedsEditing);
    }

    if (canSeeNeedsEditing && thumbnail.hasOldNeedsEditing && !thumbnail.needsEditing) {
        icons.push(ThumbnailActionIcon.OldNeedsEditing);
    }

    if (thumbnail.hasComment) {
        icons.push(ThumbnailActionIcon.HasComment);
    }

    if (thumbnail.hasOldComment && !thumbnail.hasComment) {
        icons.push(ThumbnailActionIcon.HasOldComment);
    }

    return icons;
}
